const closeButtonLabel = "Sulje";
const fiFI = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  fiFI as default
};
